export const projects = [
  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/unacademy.png?raw=true",
    title: "Unacademy Clone",
    des: "Unacademy is an e-learning application. This was a team project where I with my teammates had created a learning platform for classes 6 to 12. Feel free to contact us for any queries or feedback.",
    demo: "",
    live: "https://unacademy-clone.vercel.app/",
    gitHub: "https://github.com/RahulGoyal03/unacademy_clone",
    technologies: ["HTML", "CSS", "JavaScript", "React", "Redux", "Firebase"],
  },
  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/pepperfry.png?raw=true",
    title: "Pepperfry Backend",
    des: "This is the clone of www.pepperfry.com , which is an e-commerce website of a furniture. This is our team collaboration project at Full Stack-development bootcamp in Masai School.",
    demo: "",
    live: "https://pepperfry-clone-silk.vercel.app/",
    gitHub: "https://github.com/RahulGoyal03/PEPPERFRY-CLONE-BACKEND",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "MongoDB",
      "Mongoose",
      "ExpressJS",
      "NodeJs",
    ],
  },
  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/pepperfry1.png?raw=true",
    title: "Pepperfry Clone",
    des: "Pepperfry is an Indian online marketplace for furniture and home decor. In this project we have tried to make the same site with our effects and technolgy stacks, we were able to clone the frontend with high precision and quality.",
    demo: "",
    live: "https://pepperfry-clone-silk.vercel.app/",
    gitHub: "https://github.com/RahulGoyal03/Pepperfry-Clone",
    technologies: ["HTML", "CSS", "JavaScript", "NodeJs"],
  },

  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/plumgoodness.png?raw=true",
    title: "Plumgoodness Clone",
    des: "Plumgoodness is an Indian e-commerce website for purchasing herbal skin products or cosmetics. We cloned only the frontend part of the plumgoodness.com website with all major functionalities. We have tried to make the same site with our effects and technolgy stacks.",
    demo: "",
    live: "https://plumgoodness.netlify.app/",
    gitHub: "https://github.com/RahulGoyal03/PLUM",
    technologies: ["HTML", "CSS", "javaScript"],
  },
  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/TodoApp.png?raw=true",
    title: "Todo App",
    des: "A ToDo application made using Html, CSS and JavaScript, wherein the user can add a new task, change the status of it, and delete it.",
    demo: "",
    live: "https://rahultodoapp.netlify.app/",
    gitHub: "https://github.com/RahulGoyal03/TODO-LIST",
    technologies: ["HTML", "CSS", "JavaScript"],
  },
  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/youtube.jpg?raw=true",
    title: "Youtube API",
    des: "Here is YouTube clone which fetch the data from the Youtube Api and display the videos on page and user also search the videos on the search bar and play it.",
    demo: "",
    live: "https://youtubeapplication.netlify.app/",
    gitHub: "https://github.com/RahulGoyal03/Youtube-",
    technologies: ["HTML", "CSS", "javaScript"],
  },
  {
    img: "https://github.com/RahulGoyal03/Portfolio/blob/main/public/projectImages/hotstar.png?raw=true",
    title: "My Movie Website",
    des: "Here I have created a movie web application where user will get category based movies and also can search for a movie. Here user will get all info related to a particular movie.",
    demo: "",
    live: "https://mini-hotstar.netlify.app/",
    gitHub: "https://github.com/RahulGoyal03/Hotstar-Debouncing",
    technologies: ["HTML", "CSS", "javaScript"],
  },
];
